import { noop } from 'lodash-es';

export type FileUploadOptions = {
  multiple?: boolean;
  accept?: string;
};

export function useFileUpload(
  onUpload: (files: File[]) => void,
  { multiple = false, accept }: FileUploadOptions = {}
) {
  if (typeof window === 'undefined') return { uploadFile: noop };

  const input = document.createElement('input');
  input.type = 'file';
  input.multiple = multiple;
  input.accept = accept ?? '';
  input.onchange = (event: Event) => {
    const target = event.target as HTMLInputElement;
    if (!target.files || target.files.length === 0) return;
    onUpload(Array.from(target.files));
  };

  const uploadFile = () => input.click();
  return { uploadFile };
}
